/**
 * Extracts the product UID from commodity pack data, e.g. "UM339b2"
 * @param {object} data - Commodity pack item
 * @returns {string|null|undefined}
 */
export function getUid(data) {
    if (!data) return;
    try {
        // 1. attempt - image URL -> "https://image.alza.cz/products/UM339b2/UM339b2.jpg?width=190&height=190"
        const regex = /^https:\/\/image\.alza\.\w{2}\/products\/([A-Za-z0-9]+)\/\1\.jpg\?width=\d+&height=\d+$/;
        if (regex.test(data.imageUrl)) {
            return data.imageUrl.split("?").shift().split("/").pop().split(".").shift();
        }

        // 2. attempt - onAddClick object
        return data.onAddClick.analytics.actions.onClick.data.item_id;
    }
    catch (error) {
        console.error('Error extracting UID:', error);
        return null;
    }
}
